export enum OrganizationType {
  ACADEMIC = 'academic',
  CLUB_SPORTS = 'club_sports',
  COMMUNITY_SERVICE = 'community_service',
  CULTURAL_IDENTITY = 'cultural_identity',
  DEPARTMENTAL = 'departmental',
  FRATERNITY = 'fraternity',
  GOVERNANCE = 'governance',
  HONORS = 'honors',
  INTERNATIONAL_ORGANIZATION = 'international_organization',
  MEDIA_PUBLICATION = 'media_publication',
  RELIGIOUS = 'religious',
  RESIDENTIAL_LIFE = 'residential_life',
  PERFORMING_ARTS = 'performing_arts',
  POLITICAL_ADVOCACY = 'political_advocacy',
  PROFESSIONAL = 'professional',
  HOBBY_SPECIAL_INTEREST = 'hobby_special_interest',
  STATE_CITY_CLUB = 'state_city_club',
  SORORITY = 'sorority',
  OTHER = 'other',
}

export const ORGANIZATION_TYPE_LABELS: Record<OrganizationType, string> = {
  [OrganizationType.ACADEMIC]: 'Academic',
  [OrganizationType.CLUB_SPORTS]: 'Athletics & Club Sports',
  [OrganizationType.COMMUNITY_SERVICE]: 'Community Service',
  [OrganizationType.CULTURAL_IDENTITY]: 'Cultural/Identity',
  [OrganizationType.DEPARTMENTAL]: 'Departmental',
  [OrganizationType.FRATERNITY]: 'Fraternity',
  [OrganizationType.GOVERNANCE]: 'Governance',
  [OrganizationType.HONORS]: 'Honors',
  [OrganizationType.INTERNATIONAL_ORGANIZATION]: 'International Organization',
  [OrganizationType.MEDIA_PUBLICATION]: 'Media/Publication',
  [OrganizationType.RELIGIOUS]: 'Religious',
  [OrganizationType.RESIDENTIAL_LIFE]: 'Residential Life',
  [OrganizationType.PERFORMING_ARTS]: 'Performing Arts',
  [OrganizationType.POLITICAL_ADVOCACY]: 'Political/Advocacy',
  [OrganizationType.PROFESSIONAL]: 'Professional',
  [OrganizationType.HOBBY_SPECIAL_INTEREST]: 'Hobby/Special Interest',
  [OrganizationType.STATE_CITY_CLUB]: 'State/City Club',
  [OrganizationType.SORORITY]: 'Sorority',
  [OrganizationType.OTHER]: 'Other',
};

/**
 * Display order for the checkbox grid on the Organization Profile page.
 * Matches Figma 21Txg59PEcXxNHpDeqrfS9 / 8722:4775. Athletics is shown as
 * "Athletics & Club Sports" on the club_sports value. "Other" stays last.
 */
export const ORGANIZATION_TYPE_DISPLAY_ORDER: readonly OrganizationType[] = [
  OrganizationType.ACADEMIC,
  OrganizationType.CLUB_SPORTS,
  OrganizationType.COMMUNITY_SERVICE,
  OrganizationType.CULTURAL_IDENTITY,
  OrganizationType.DEPARTMENTAL,
  OrganizationType.FRATERNITY,
  OrganizationType.GOVERNANCE,
  OrganizationType.HOBBY_SPECIAL_INTEREST,
  OrganizationType.HONORS,
  OrganizationType.INTERNATIONAL_ORGANIZATION,
  OrganizationType.MEDIA_PUBLICATION,
  OrganizationType.PERFORMING_ARTS,
  OrganizationType.POLITICAL_ADVOCACY,
  OrganizationType.PROFESSIONAL,
  OrganizationType.RELIGIOUS,
  OrganizationType.RESIDENTIAL_LIFE,
  OrganizationType.SORORITY,
  OrganizationType.STATE_CITY_CLUB,
  OrganizationType.OTHER,
];
